

import React from 'react'
import PageHeader from '../components/PageHeader'

const Paperless_Ecofriendly_class = () => {
    return (
        <div>
            <PageHeader title="Paperless Ecofriendly class" />
        </div>
    )
}

export default Paperless_Ecofriendly_class